import { Broker, CodeDeployment } from '@amzn/amazonmq-opsconsole-client';
import { useEffect, useState } from 'react';
import { getCodeDeployments } from '../../../../api/api';

interface Props {
    broker: Broker;
    refreshCnt: number;
    timestampFrom: number;
    timestampTo: number;
    setLatestDeployment?: (deployment: CodeDeployment | undefined) => void;
}

export const useCodeDeploy = ({
    broker,
    refreshCnt,
    timestampFrom,
    timestampTo,
    setLatestDeployment,
}: Props) => {
    const [deployments, setDeployments] = useState<CodeDeployment[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (timestampTo != null && timestampFrom > timestampTo) {
            console.warn('Invalid timestamp range: fromTimestamp is greater than toTimestamp');
            setDeployments([]);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            getCodeDeployments(broker.id, timestampFrom, timestampTo)
                .then(response => {
                    setDeployments(response.codeDeployments)
                    if (setLatestDeployment && response.codeDeployments.length > 0) {
                        const latest = response.codeDeployments.reduce((latest, current) =>
                            current.startTime > latest.startTime ? current : latest);
                        setLatestDeployment(latest);
                    } else if (setLatestDeployment) {
                        setLatestDeployment(undefined);
                    }
                })
                .catch(error => {
                    console.error("getCodeDeployments failed to fetch: " + error);
                    setError(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error(error);
            setError(error instanceof Error ? error : new Error('Unknown error occurred'));
        } finally {
            setLoading(false);
        }
    }, [broker, refreshCnt, timestampFrom, timestampTo]);

    return { deployments, loading, error };
};